import { render, staticRenderFns } from "./ViewCustomer.vue?vue&type=template&id=326cb1a9&scoped=true&"
import script from "./ViewCustomer.vue?vue&type=script&lang=ts&"
export * from "./ViewCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./ViewCustomer.vue?vue&type=style&index=0&id=326cb1a9&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326cb1a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VDivider,VForm,VIcon,VRow,VSpacer,VTooltip})
